import React, {FC} from 'react';
import './style.scss';
import {pathSuite} from "../../../constants";
import MixWeekButton from "../../form/MixWeekButton";
import {IOSSlider, marks} from "./Slider";
import Img from 'react-image';
import noMix from '../../../assets/img/no__mix.png';
import {isNil} from "../../../services/utils/isNil";

interface IMixWeekCard {
    imageUrl: string,
    brandTobacco: string,
    nameTobacco: string,
    amountTobacco: number,
    id: number,
    setValues: any,
    values: Array<number>
}

const MixCard: FC<IMixWeekCard> = ({
                                       id,
                                       imageUrl,
                                       brandTobacco,
                                       nameTobacco,
                                       amountTobacco,
                                       setValues,
                                       values
                                   }) => {

    const changeHandler = (event: any, currentValue: any) => {
        let currentSlider = event.target.getAttribute('aria-labelledby');
        if (isNil(currentSlider)) {
            return false;
        } else {
            currentSlider = +currentSlider;
        }
        const copiedValues = [...values];
        copiedValues[currentSlider] = currentValue;
        const amountUnchanged = Math.abs(copiedValues
            .filter((item: number, index) => index !== currentSlider)
            .reduce((acc: number, val: number) => acc + val));
        const valueToAdd = Math.ceil((((100 - currentValue) - amountUnchanged) / copiedValues.length - 1));
        const newState = copiedValues.map((item: number, index) => {
            if (index === currentSlider) return item;
            const returnValue = Math.ceil(item + valueToAdd);
            return returnValue < 0 ? 0 : returnValue;
        });
        setValues(newState);
    };

    return (
        <div className="mix-week-page__card">
            <div className="mix-week-page__outer">
                <div className="mix-week-page__wrapper">
                    <div className="mix-week-page__card-container">
                        <Img
                            className="mix-week-page__card-img"
                            src={[pathSuite + imageUrl, noMix]}
                            loader={<Img
                                src={noMix}
                                className="mix-week-page__card-img"
                                alt="Preloader"/>}
                        />
                        <div className="mix-week-page__info">
                            <div className="mix-week-page__tobacco-name">
                                {
                                    nameTobacco.length > 34
                                        ? nameTobacco
                                            .slice(0, 34)
                                        + "..."
                                        : nameTobacco
                                }
                            </div>
                            <div className="mix-week-page__brand-name">
                                <MixWeekButton>
                                    <span
                                        className="mix-week-page__button-brand">
                                        {brandTobacco}
                                    </span>
                                </MixWeekButton>
                            </div>
                        </div>
                    </div>
                    <div className="mix-week-page__slider-container">
                        <IOSSlider
                            className="mix-week-page__slider"
                            aria-labelledby={id.toString()}
                            onChange={changeHandler}
                            valueLabelDisplay="on"
                            marks={marks}
                            min={0}
                            max={100}
                            value={amountTobacco}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MixCard;
